module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container",
    staticStyle: {
      "border-bottom": "1px solid rgba(222, 222, 222, 0.57)"
    },
    attrs: {
      "id": "header"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-xl navbar-light",
    staticStyle: {
      "font-color": "#0082ba",
      "font-size": "12px",
      "max-width": "1490px",
      "margin": "auto"
    },
    attrs: {
      "id": "navbar"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "https://amcredit.com"
    }
  }, [_c('img', {
    staticClass: "img-fluid logo",
    attrs: {
      "src": require('../../assets/imgs/American Credit_logo_TM_a.png'),
      "srcset": require('../../assets/imgs/American-Credit-logo-TM-320w.png') +
        ' 320w, ' +
        require('../../assets/imgs/American-Credit-logo-TM-640w.png') +
        ' 640w, ' +
        require('../../assets/imgs/American-Credit-logo-TM-960w.png') +
        ' 960w',
      "alt": "American Credit Logo",
      "width": "240",
      "height": "62"
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse my-3 my-xl-0",
    attrs: {
      "id": "navbarsDefault"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "navbar-nav justify-content-end self-align-right align-items-right h6 mt-3 mt-lg-0",
    staticStyle: {
      "margin": "0 0 0 auto"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "btn-group align-items-center"
  }, [(_vm.isLogin) ? [_c('a', {
    staticClass: "nav-item px-2 nav-link text-nowrap",
    on: {
      "click": _vm.confirmLogout
    }
  }, [_vm._v("Log Out")])] : [_c('a', {
    staticClass: "nav-item px-2 text-nowrap",
    staticStyle: {
      "font-family": "Helvetica",
      "color": "#5456ff",
      "font-size": "16px",
      "font-weight": "700"
    },
    attrs: {
      "href": "/login",
      "onClick": "window.location='/login'"
    }
  }, [_vm._v("Sign In")])], _vm._v(" "), (_vm.isLogin) ? [_c('div', [_c('li', {
    staticClass: "px-2"
  }, [(_vm.employer.customerType == '1') ? _c('router-link', {
    staticClass: "text-danger text-nowrap",
    attrs: {
      "to": "/personalCenter"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("ellipsis")(_vm.employer.name)) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.employer.customerType == '8') ? _c('router-link', {
    staticClass: "text-danger text-nowrap",
    attrs: {
      "to": "/brokerCenter"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("ellipsis")(_vm.employer.name)) + "\n                  ")]) : _vm._e()], 1)])] : _vm._e(), _vm._v(" "), (_vm.isLogin) ? void 0 : [_c('router-link', {
    staticClass: "cta ml-3",
    attrs: {
      "to": "/get-start",
      "tag": "button"
    }
  }, [_vm._v("Apply Now")])]], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row flex-nowrap ml-auto mr-3 d-none d-md-flex d-xl-none"
  }, [_c('div', {
    staticClass: "container contact-card mr-1"
  }, [_c('div', {
    staticClass: "row align-items-center flex-nowrap"
  }, [_c('div', {
    staticClass: "col-auto pl-0"
  }, [_c('img', {
    staticClass: "rounded-circle",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": require("../../assets/imgs/lei-small.png"),
      "alt": "Lei Photo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row mb-1"
  }, [_c('div', {
    staticClass: "col-1 pl-0 pr-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col pl-0 consultant-name"
  }, [_vm._v("Call Amcredit")])]), _vm._v(" "), _c('div', {
    staticClass: "row flex-nowrap consultant-phone"
  }, [_c('div', {
    staticClass: "col-1 pl-0 pr-3"
  }, [_c('span', {
    staticClass: "phone-icon fa fa-phone"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col pl-0 text-nowrap"
  }, [_vm._v("\n                  Sales:\n                  "), _c('a', {
    staticClass: "consultant-phone_number",
    attrs: {
      "href": "tel:8559040188"
    }
  }, [_vm._v("855-904-0188")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarsDefault",
      "aria-controls": "navbarsDefault",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "navbar-nav h6 desktop-nav"
  }, [_c('div', {
    staticClass: "btn-group align-items-center main-item"
  }, [_c('a', {
    staticClass: "nav-item px-2 pt-2 nav-link text-xl-center text-xxl-left",
    staticStyle: {
      "font-family": "Helvetica",
      "font-weight": "600",
      "cursor": "pointer"
    },
    attrs: {
      "aria-haspopup": "true",
      "href": "https://amcredit.com/equipment-loan"
    }
  }, [_vm._v("Asset-based Loans")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/equipment-loan"
    }
  }, [_vm._v("Equipment Loans")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/invoice-factoring"
    }
  }, [_vm._v("Invoice/AR Factoring")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/vendor-financing"
    }
  }, [_vm._v("Vendor Financing")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group align-items-center main-item"
  }, [_c('a', {
    staticClass: "nav-item px-2 pt-2 nav-link",
    staticStyle: {
      "font-family": "Helvetica",
      "font-weight": "600",
      "cursor": "pointer"
    },
    attrs: {
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "href": "https://amcredit.com/industries"
    }
  }, [_vm._v("Industries")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/industries/commercial-truck-financing"
    }
  }, [_vm._v("Trucking")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/industries/loans-for-contractors"
    }
  }, [_vm._v("Contractors")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/industries/commercial-construction-loans"
    }
  }, [_vm._v("Construction")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/industries/manufacturing-financing"
    }
  }, [_vm._v("Manufacturing")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/industries/excavator-financing"
    }
  }, [_vm._v("Excavating")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/industries/loans-for-restaurants"
    }
  }, [_vm._v("Restaurants")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/industries/loans-for-landscapers"
    }
  }, [_vm._v("Landscaping")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/industries/transportation-business-loans"
    }
  }, [_vm._v("Transportation")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/industries/commercial-vehicle-loans"
    }
  }, [_vm._v("Commercial Vehicles")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/industries/loans-for-farmers"
    }
  }, [_vm._v("Farming")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/industries/commercial-real-estate-loans"
    }
  }, [_vm._v("Commercial Real Estate")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/industries/working-capital-financing"
    }
  }, [_vm._v("Working Capital")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group align-items-center main-item"
  }, [_c('a', {
    staticClass: "nav-item px-2 pt-2 nav-link",
    staticStyle: {
      "font-family": "Helvetica",
      "font-weight": "600",
      "cursor": "pointer"
    },
    attrs: {
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "href": "https://amcredit.com/blog"
    }
  }, [_vm._v("Resources")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/loan-calculator"
    }
  }, [_vm._v("Loan Calculator")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/roi-calculator"
    }
  }, [_vm._v("ROI Calculator")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/faq"
    }
  }, [_vm._v("FAQs")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/blog"
    }
  }, [_vm._v("Blog")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group align-items-center main-item"
  }, [_c('a', {
    staticClass: "nav-item px-2 pt-2 nav-link",
    staticStyle: {
      "font-family": "Helvetica",
      "font-weight": "600",
      "cursor": "pointer"
    },
    attrs: {
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "href": "https://amcredit.com/about-us"
    }
  }, [_vm._v("Company")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/partners"
    }
  }, [_vm._v("Partners")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/brokers"
    }
  }, [_vm._v("Brokers")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/careers"
    }
  }, [_vm._v("Careers")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/about-us"
    }
  }, [_vm._v("About Us")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item nav-link",
    attrs: {
      "href": "https://amcredit.com/team"
    }
  }, [_vm._v("Team")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container contact-card ml-0 mr-lg-1 ml-lg-2 mb-3 mb-lg-0 d-md-none d-xl-block"
  }, [_c('div', {
    staticClass: "row align-items-center flex-nowrap"
  }, [_c('div', {
    staticClass: "col-auto pl-2 pl-lg-0"
  }, [_c('img', {
    staticClass: "rounded-circle",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": require("../../assets/imgs/lei-small.png"),
      "alt": "Lei Photo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row mb-1"
  }, [_c('div', {
    staticClass: "col-1 pl-0 pr-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col pl-0 consultant-name"
  }, [_vm._v("Call Amcredit")])]), _vm._v(" "), _c('div', {
    staticClass: "row flex-nowrap consultant-phone"
  }, [_c('div', {
    staticClass: "col-1 pl-0 pr-3"
  }, [_c('span', {
    staticClass: "phone-icon fa fa-phone"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col pl-0 text-nowrap"
  }, [_vm._v("\n                    Sales:\n                    "), _c('a', {
    staticClass: "consultant-phone_number",
    attrs: {
      "href": "tel:8559040188"
    }
  }, [_vm._v("855-904-0188")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41c50af9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Header.vue
// module id = 1969
// module chunks = 5